function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#79ccca;}.cls-5{fill:#7cd1cf;}.cls-6{fill:#7fd6d4;}.cls-7{fill:#82dbd9;}.cls-8{fill:#85e0de;}.cls-9{fill:#88e6e3;}.cls-10{fill:#8bebe8;}.cls-11{fill:#8ef0ed;}.cls-12{fill:#91f5f2;}.cls-13{fill:#94faf7;}.cls-14{fill:#97fffc;}.cls-15{fill:#a3fffc;}.cls-16{fill:#a9fffd;}.cls-17{fill:#adfffd;}.cls-18{fill:#b0fffd;}.cls-19{fill:#b3fffd;}.cls-20{fill:#b6fffd;}.cls-21{fill:#b8fffd;}.cls-22{fill:#bafffd;}.cls-23{fill:#bcfffd;}.cls-24{fill:#befffd;}.cls-25{fill:#c0fffd;}.cls-26{fill:#c2fffd;}.cls-27{fill:#c4fffd;}.cls-28{fill:#c6fffd;}.cls-29{fill:#c7fffd;}.cls-30{fill:#c9fffd;}.cls-31{fill:#cafffd;}.cls-32{fill:#ccfffe;}.cls-33{fill:#cdfffe;}.cls-34{fill:#cffffe;}.cls-35{fill:#d0fffe;}.cls-36{fill:#d2fffe;}.cls-37{fill:#76c7c5;}.cls-38{fill:#73c2c0;}.cls-39{fill:#70bdba;}.cls-40{fill:#6db8b5;}.cls-41{fill:#6ab3b0;}.cls-42{clip-path:url(#clip-path-2);}.cls-43{clip-path:url(#clip-path-3);}.cls-44{fill:#67adab;}.cls-45{fill:#7fd7d4;}.cls-46{fill:#82dcd9;}.cls-47{fill:#7bd0ce;}.cls-48{clip-path:url(#clip-path-4);}.cls-49{fill:#528a88;}.cls-50{fill:#558f8d;}.cls-51{fill:#589492;}.cls-52{fill:#5b9997;}.cls-53{fill:#5e9e9c;}.cls-54{fill:#61a3a1;}.cls-55{fill:#64a8a6;}.cls-56{clip-path:url(#clip-path-5);}.cls-57{fill:#4f8583;}.cls-58{clip-path:url(#clip-path-6);}.cls-59{clip-path:url(#clip-path-7);}.cls-60{clip-path:url(#clip-path-8);}.cls-61{clip-path:url(#clip-path-9);}.cls-62{fill:#73c3c1;}.cls-63{fill:#75c5c2;}.cls-64{fill:#6ebab8;}.cls-65{clip-path:url(#clip-path-10);}.cls-66{clip-path:url(#clip-path-11);}.cls-67{clip-path:url(#clip-path-12);}.cls-68{clip-path:url(#clip-path-13);}.cls-69{clip-path:url(#clip-path-14);}.cls-70{clip-path:url(#clip-path-15);}.cls-71{clip-path:url(#clip-path-16);}.cls-72{clip-path:url(#clip-path-17);}.cls-73{clip-path:url(#clip-path-18);}.cls-74{clip-path:url(#clip-path-19);}.cls-75{fill:#2f9c9c;}.cls-76{fill:#30a0a0;}.cls-77{fill:#31a5a5;}.cls-78{fill:#32a8a8;}.cls-79{clip-path:url(#clip-path-20);}.cls-80{fill:#35b1b1;}.cls-81{fill:#34adad;}.cls-82{fill:#32a9a9;}.cls-83{clip-path:url(#clip-path-21);}.cls-84{fill:#216e6e;}.cls-85{fill:#35b3b3;}.cls-86{clip-path:url(#clip-path-22);}.cls-87{fill:#36b5b5;}.cls-88{fill:#37baba;}.cls-89{fill:#39bebe;}.cls-90{clip-path:url(#clip-path-23);}.cls-91{fill:#257a7a;}.cls-92{fill:#267f7f;}.cls-93{fill:#278383;}.cls-94{fill:#288787;}.cls-95{fill:#2a8b8b;}.cls-96{fill:#2b8f8f;}.cls-97{fill:#3cc8c8;}.cls-98{fill:#2e9b9b;}.cls-99{fill:#247878;}.cls-100{fill:#38bbbb;}.cls-101{fill:#38baba;}.cls-102{clip-path:url(#clip-path-24);}.cls-103{fill:#2c9494;}.cls-104{fill:#237676;}.cls-105{fill:#227272;}.cls-106{clip-path:url(#clip-path-25);}.cls-107{fill:#3ac2c2;}.cls-108{opacity:0.25;}.cls-109{clip-path:url(#clip-path-26);}.cls-110{fill:#fff;}"), React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M159.3,1122.25C95.79,1085.59,44.47,996.71,44.68,923.72l11.7-3.51c-.2,71.18,49.86,157.87,111.8,193.63Z"
})), React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M120.65,1144.72C57.14,1108.05,5.82,1019.17,6,946.19l38.65-22.47c-.21,73,51.11,161.87,114.62,198.53Z"
})), React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M111.79,1146.61C49.85,1110.85-.2,1024.16,0,953l6-6.79c-.21,73,51.11,161.86,114.62,198.53Z"
})), React.createElement("clipPath", {
  id: "clip-path-4",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M400.4,1293.44c-17.33,2.54-37.83-2-59.78-14.72l8.86-1.89c22.51,13,43.52,17.69,61.29,15.09Z"
})), React.createElement("clipPath", {
  id: "clip-path-5",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M486.28,1248c-20.36,26-56.73,30.24-98.15,6.33L397,1246c40.39,23.32,75.87,19.23,95.72-6.18l-.32.42-.33.41-.32.41c-.75,1-1.51,1.93-2.26,2.89Z"
})), React.createElement("clipPath", {
  id: "clip-path-6",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M431.31,1284.85c-20.91,12.15-49.87,10.44-81.83-8l38.65-22.46c32,18.45,60.93,20.17,81.84,8Z"
})), React.createElement("clipPath", {
  id: "clip-path-7",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M492.73,1239.78l-3.55,4.55q-1.46,1.85-2.9,3.71c10.86-13.9,17.16-34,17.23-59.41l6-6.79C509.47,1206.6,503.32,1226.23,492.73,1239.78Z"
})), React.createElement("clipPath", {
  id: "clip-path-8",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M470,1262.39l-38.66,22.46c20.64-12,33.44-37.5,33.55-73.76l38.65-22.46C503.41,1224.88,490.61,1250.39,470,1262.39Z"
})), React.createElement("clipPath", {
  id: "clip-path-9",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M410.77,1291.92l-10.37,1.52c31.57-4.63,52.62-32.88,52.75-78.83l11.71-3.52C464.72,1258.21,443.14,1287.18,410.77,1291.92Z"
})), React.createElement("clipPath", {
  id: "clip-path-10",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M25.58,69.66c-10.86,13.9-17.16,34-17.24,59.41l-6,6.79c.07-24.76,6.21-44.39,16.81-58l.32-.41.32-.41.65-.83.32-.41.65-.83.32-.41.64-.83Z"
})), React.createElement("clipPath", {
  id: "clip-path-11",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M111.46,24.26C79.88,28.88,58.83,57.14,58.7,103.1L47,106.61c.13-47.12,21.71-76.09,54.09-80.83Z"
})), React.createElement("clipPath", {
  id: "clip-path-12",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M80.54,32.85C59.9,44.84,47.1,70.35,47,106.61L8.34,129.07c.11-36.25,12.91-61.76,33.55-73.76Z"
})), React.createElement("clipPath", {
  id: "clip-path-13",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M101.09,25.78l10.37-1.52c17.32-2.54,37.82,2,59.76,14.71l-8.85,1.89C139.87,27.87,118.85,23.18,101.09,25.78Z"
})), React.createElement("clipPath", {
  id: "clip-path-14",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M41.89,55.31,80.54,32.85c20.91-12.15,49.87-10.44,81.83,8L123.71,63.32C91.76,44.87,62.8,43.16,41.89,55.31Z"
})), React.createElement("clipPath", {
  id: "clip-path-15",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M19.13,77.91l6.45-8.25c20.36-26,56.72-30.25,98.13-6.34l-8.87,8.41C74.45,48.42,39,52.51,19.13,77.91Z"
})), React.createElement("clipPath", {
  id: "clip-path-16",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M391.2,173l8.86-1.9c61.94,35.77,112,122.47,111.79,193.65l-6,6.79C506,298.53,454.71,209.65,391.2,173Z"
})), React.createElement("clipPath", {
  id: "clip-path-17",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M352.55,195.44,391.2,173C454.71,209.65,506,298.53,505.83,371.52L467.17,394C467.38,321,416.06,232.11,352.55,195.44Z"
})), React.createElement("clipPath", {
  id: "clip-path-18",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M343.67,203.85l8.88-8.41C416.06,232.11,467.38,321,467.17,394l-11.7,3.51C455.67,326.31,405.62,239.61,343.67,203.85Z"
})), React.createElement("clipPath", {
  id: "clip-path-19",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M307.25,144.39l-3.17-1c4.66-3.12,13.15-3.17,18.95-.1l-2.44,1C316.51,142.17,310.52,142.2,307.25,144.39Z"
})), React.createElement("clipPath", {
  id: "clip-path-20",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M307.73,152.94l-2.55,2.3c-5.8-3.06-6.73-8.08-2.07-11.2l3.16,1C303,147.24,303.65,150.78,307.73,152.94Z"
})), React.createElement("clipPath", {
  id: "clip-path-21",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M299.91,151.17l.25-2.78c-.22,2.43,1.51,5,5,6.85l-.25,2.78C301.42,156.17,299.69,153.6,299.91,151.17Z"
})), React.createElement("clipPath", {
  id: "clip-path-22",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M376,173.58l2.44-1c5.81,3.06,6.74,8.08,2.08,11.2l-3.06-2.28C380.73,179.28,380.08,175.74,376,173.58Z"
})), React.createElement("clipPath", {
  id: "clip-path-23",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M383.46,179.4l-.25,2.78a6,6,0,0,1-2.95,4.35l.25-2.78A6,6,0,0,0,383.46,179.4Z"
})), React.createElement("clipPath", {
  id: "clip-path-24",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M379.53,184.4l-.24,2.78c-4.66,3.12-13.15,3.17-19,.1l.25-2.78C366.39,187.57,374.88,187.52,379.53,184.4Z"
})), React.createElement("clipPath", {
  id: "clip-path-25",
  transform: "translate(0 -23.58)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M376.48,182.12l3,2.28c-4.65,3.12-13.14,3.17-18.95.1l2.55-2.31C367.22,184.35,373.2,184.32,376.48,182.12Z"
})), React.createElement("clipPath", {
  id: "clip-path-26",
  transform: "translate(0 -23.58)"
}, React.createElement("polygon", {
  className: "cls-1",
  points: "1.75 1081.39 4.82 0 463.64 264.9 460.58 1346.3 1.75 1081.39"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "TransparentPhone");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "TransparentPhone"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-3"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-4",
  d: "M159.3,1122.25l8.88-8.41c-1-.6-2.07-1.21-3.1-1.83l-9,8.36c1.05.65,2.11,1.27,3.17,1.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M156.13,1120.37l9-8.36q-2.43-1.48-4.85-3.07l-9.07,8.29c1.65,1.08,3.3,2.13,5,3.14",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M151.16,1117.23l9.07-8.29c-1.55-1-3.1-2.08-4.64-3.17L146.4,1114c1.58,1.11,3.16,2.2,4.76,3.25",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M146.4,1114l9.19-8.21q-2.28-1.61-4.53-3.3l-9.31,8.12q2.31,1.74,4.65,3.39",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M141.75,1110.59l9.31-8.12c-1.33-1-2.65-2-4-3.08l-9.4,8c1.34,1.07,2.7,2.12,4.06,3.15",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M137.69,1107.44l9.4-8c-1.26-1-2.51-2-3.76-3.07l-9.5,8c1.28,1.07,2.56,2.12,3.86,3.15",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M133.83,1104.29l9.5-8q-1.67-1.39-3.31-2.84l-9.59,7.9q1.69,1.47,3.4,2.91",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M130.43,1101.38l9.59-7.9c-.92-.81-1.84-1.62-2.75-2.45l-9.66,7.83,2.82,2.52",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M127.61,1098.86l9.66-7.83q-1.38-1.24-2.73-2.52l-9.73,7.77c.93.87,1.86,1.73,2.8,2.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M124.81,1096.28l9.73-7.77c-.82-.77-1.63-1.55-2.44-2.33l-9.79,7.71c.83.81,1.66,1.6,2.5,2.39",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M122.31,1093.89l9.79-7.71c-.65-.62-1.29-1.25-1.93-1.89l-9.84,7.67,2,1.93",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M120.33,1092l9.84-7.67-1.91-1.91-9.88,7.61,2,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M118.38,1090l9.88-7.61-1.89-2-9.93,7.57c.64.67,1.29,1.33,1.94,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M116.44,1088l9.93-7.57-1.86-2-10,7.51c.63.68,1.27,1.35,1.91,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M114.53,1086l10-7.51c-.49-.52-1-1-1.45-1.57l-10,7.48c.49.54,1,1.07,1.49,1.6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M113,1084.38l10-7.48c-.49-.52-1-1.05-1.45-1.58l-10,7.44,1.48,1.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-20",
  d: "M111.56,1082.76l10-7.44-1.43-1.59-10.09,7.39,1.47,1.64",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-21",
  d: "M110.09,1081.12l10.09-7.39-1.42-1.62-10.13,7.36,1.46,1.65",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-22",
  d: "M108.63,1079.47l10.13-7.36c-.48-.54-1-1.08-1.41-1.63l-10.17,7.32,1.45,1.67",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-23",
  d: "M107.18,1077.8l10.17-7.32-1.35-1.57-10.19,7.27,1.37,1.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-24",
  d: "M105.81,1076.18l10.19-7.27c-.43-.51-.86-1-1.28-1.54l-10.23,7.24,1.32,1.57",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-25",
  d: "M104.49,1074.61l10.23-7.24c-.43-.51-.85-1-1.27-1.54L103.19,1073l1.3,1.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-26",
  d: "M103.19,1073l10.26-7.19-1.27-1.56-10.29,7.16,1.3,1.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-27",
  d: "M101.89,1071.43l10.29-7.16-1.25-1.57-10.32,7.12,1.28,1.61",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-28",
  d: "M100.61,1069.82l10.32-7.12-1.24-1.58-10.36,7.07,1.28,1.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M99.33,1068.19l10.36-7.07-1.37-1.77-10.39,7,1.4,1.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-30",
  d: "M97.93,1066.38l10.39-7c-.49-.64-1-1.28-1.45-1.93l-10.43,7c.49.66,1,1.31,1.49,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-31",
  d: "M96.44,1064.41l10.43-7c-.49-.64-1-1.28-1.44-1.93L95,1062.42c.49.67,1,1.33,1.48,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-32",
  d: "M95,1062.42l10.47-6.93-1.43-2-10.49,6.88,1.45,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-33",
  d: "M93.51,1060.42l10.49-6.88c-.47-.66-.94-1.31-1.4-2l-10.54,6.83c.48.68,1,1.35,1.45,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-34",
  d: "M92.06,1058.4l10.54-6.83c-.76-1.07-1.52-2.15-2.26-3.24l-10.59,6.76c.76,1.11,1.53,2.21,2.31,3.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-35",
  d: "M89.75,1055.09l10.59-6.76q-1.44-2.08-2.83-4.2l-10.66,6.65q1.43,2.16,2.9,4.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-36",
  d: "M86.85,1050.78l10.66-6.65q-3.84-5.84-7.4-11.88l-10.85,6.35q3.64,6.2,7.59,12.18",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-35",
  d: "M79.26,1038.6l10.85-6.35q-1.19-2-2.32-4l-10.91,6.25q1.17,2.07,2.38,4.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-34",
  d: "M76.88,1034.48l10.91-6.25-1.43-2.56-11,6.18,1.47,2.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-33",
  d: "M75.41,1031.85l11-6.18c-.48-.86-.94-1.72-1.41-2.58l-11,6.12,1.44,2.64",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-32",
  d: "M74,1029.21l11-6.12c-.46-.86-.92-1.72-1.37-2.59l-11,6,1.41,2.66",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-31",
  d: "M72.56,1026.55l11-6-1.08-2.08-11,6c.36.71.73,1.42,1.1,2.13",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-30",
  d: "M71.46,1024.42l11-6-.93-1.83-11.07,5.95,1,1.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M70.5,1022.54l11.07-5.95-.92-1.84-11.09,5.9c.31.63.62,1.26.94,1.89",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-28",
  d: "M69.56,1020.65l11.09-5.9c-.31-.62-.61-1.24-.91-1.85l-11.11,5.86.93,1.89",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-27",
  d: "M68.63,1018.76l11.11-5.86-.89-1.86-11.13,5.82c.3.63.61,1.26.91,1.9",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-26",
  d: "M67.72,1016.86,78.85,1011l-.87-1.85L66.82,1015l.9,1.91",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-25",
  d: "M66.82,1015,78,1009.19l-.84-1.82L66,1013.09l.86,1.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-24",
  d: "M66,1013.09l11.18-5.72-.82-1.81-11.2,5.67.84,1.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-23",
  d: "M65.12,1011.23l11.2-5.67c-.27-.61-.54-1.21-.8-1.82l-11.22,5.63.82,1.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-22",
  d: "M64.3,1009.37l11.22-5.63c-.27-.6-.53-1.21-.79-1.81l-11.24,5.58.81,1.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-21",
  d: "M63.49,1007.51l11.24-5.58L74,1000.1l-11.26,5.54c.27.62.53,1.25.8,1.87",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-20",
  d: "M62.69,1005.64,74,1000.1c-.25-.6-.51-1.21-.76-1.82l-11.28,5.49.78,1.87",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M61.91,1003.77l11.28-5.49-.84-2.07-11.3,5.44c.29.7.57,1.41.86,2.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M61.05,1001.65l11.3-5.44c-.29-.72-.58-1.44-.86-2.16l-11.32,5.38c.29.74.58,1.48.88,2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M60.17,999.43l11.32-5.38c-.28-.72-.56-1.44-.83-2.16l-11.34,5.32c.28.74.56,1.48.85,2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M59.32,997.21l11.34-5.32c-.28-.73-.55-1.45-.82-2.17L58.48,995c.28.74.55,1.48.84,2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M58.48,995l11.36-5.27-.79-2.17-11.38,5.22.81,2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M57.67,992.77l11.38-5.22c-.31-.87-.62-1.74-.92-2.61l-11.41,5.15c.31.9.63,1.79,1,2.68",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M56.72,990.09l11.41-5.15q-.51-1.46-1-2.91l-11.43,5.08c.33,1,.67,2,1,3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M55.71,987.11,67.14,982c-.33-1-.64-1.94-1-2.92l-11.46,5c.32,1,.65,2,1,3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M54.73,984.12l11.46-5c-.31-1-.62-1.94-.91-2.91L53.8,981.13c.3,1,.61,2,.93,3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M53.8,981.13l11.48-4.93c-.38-1.24-.75-2.48-1.1-3.72l-11.51,4.84c.37,1.27.74,2.54,1.13,3.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M52.67,977.32l11.51-4.84c-.38-1.33-.75-2.66-1.1-4l-11.54,4.73c.37,1.36.74,2.73,1.13,4.09",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M51.54,973.23l11.54-4.73c-.36-1.33-.7-2.66-1-4l-11.56,4.63q.51,2,1,4.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M50.49,969.15l11.56-4.63q-.61-2.49-1.16-5L49.3,964.06q.56,2.54,1.19,5.09",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M49.3,964.06l11.59-4.51q-.57-2.52-1.06-5L48.22,958.9c.34,1.72.7,3.43,1.08,5.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M48.22,958.9l11.61-4.38q-.53-2.73-1-5.44l-11.64,4.24c.31,1.86.64,3.72,1,5.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M47.21,953.32l11.64-4.24q-.48-2.8-.85-5.59L46.33,947.6q.41,2.85.88,5.72",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M46.33,947.6,58,943.49q-.39-2.85-.69-5.68l-11.68,4c.2,1.93.44,3.88.7,5.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M45.63,941.77l11.68-4q-.3-2.87-.51-5.7l-11.69,3.81q.21,2.91.52,5.85",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M45.11,935.92l11.69-3.81c-.14-1.92-.24-3.82-.31-5.72l-11.7,3.67q.1,2.93.32,5.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M44.79,930.06l11.7-3.67c-.07-1.9-.11-3.79-.11-5.67l-11.7,3.52c0,1.93,0,3.87.11,5.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M44.68,924.24l11.7-3.52v-.51l-11.7,3.51v.52",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-42"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-4",
  d: "M120.65,1144.72l38.65-22.47c-.38-.21-.75-.43-1.13-.66l-38.65,22.47,1.13.66",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M119.52,1144.06l38.65-22.47c-1.63-.95-3.25-1.95-4.87-3l-38.65,22.47c1.61,1,3.24,2,4.87,3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M114.65,1141.08l38.65-22.47q-2.45-1.56-4.88-3.22l-38.65,22.46c1.61,1.11,3.24,2.18,4.88,3.23",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M109.77,1137.85l38.65-22.46q-2.52-1.73-5-3.56l-38.65,22.46q2.48,1.83,5,3.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M104.77,1134.29l38.65-22.46q-2.55-1.87-5-3.85l-38.65,22.46c1.67,1.32,3.35,2.61,5,3.85",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M99.72,1130.44,138.37,1108c-1.72-1.36-3.42-2.75-5.12-4.18L94.6,1126.27c1.69,1.42,3.4,2.82,5.12,4.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M94.6,1126.27l38.65-22.47c-1.72-1.45-3.42-2.93-5.11-4.46l-38.65,22.47c1.69,1.52,3.39,3,5.11,4.46",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M89.49,1121.81l38.65-22.47c-1.7-1.53-3.38-3.1-5-4.69l-38.65,22.46c1.66,1.6,3.35,3.16,5,4.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M84.44,1117.11l38.65-22.46q-2.45-2.36-4.85-4.8l-38.65,22.46c1.6,1.63,3.21,3.23,4.85,4.8",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M79.59,1112.31l38.65-22.46c-1.58-1.61-3.15-3.26-4.7-4.93l-38.66,22.46c1.55,1.67,3.12,3.32,4.71,4.93",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M74.88,1107.38l38.66-22.46q-2.27-2.45-4.48-5l-38.65,22.47c1.47,1.67,3,3.33,4.47,5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M70.41,1102.43,109.06,1080c-1.5-1.7-3-3.44-4.44-5.2L66,1097.23c1.46,1.75,2.94,3.49,4.44,5.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M66,1097.23l38.65-22.47q-2.25-2.7-4.43-5.48l-38.66,22.47c1.46,1.85,2.94,3.67,4.44,5.48",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M61.53,1091.75l38.66-22.47q-2.61-3.3-5.11-6.71L56.42,1085c1.68,2.27,3.38,4.5,5.11,6.71",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M56.42,1085l38.66-22.47q-3.75-5.08-7.29-10.37l-38.65,22.46q3.53,5.29,7.28,10.38",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M49.14,1074.66l38.65-22.46q-4.44-6.66-8.52-13.59l-38.66,22.47c2.72,4.61,5.56,9.15,8.53,13.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M40.61,1061.08l38.66-22.47q-2.94-5-5.67-10.1L35,1051q2.71,5.12,5.66,10.11",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M35,1051l38.65-22.46q-1.83-3.43-3.57-6.9l-38.65,22.46c1.16,2.31,2.34,4.62,3.57,6.9",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M31.38,1044.07,70,1021.61q-1.5-3-2.93-6.07L28.44,1038c1,2,1.94,4.06,2.94,6.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M28.44,1038l38.66-22.46q-1.3-2.77-2.53-5.55l-38.65,22.46q1.23,2.79,2.52,5.55",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M25.92,1032.45,64.57,1010q-1.21-2.73-2.35-5.48L23.57,1027q1.14,2.74,2.35,5.48",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M23.57,1027l38.65-22.46q-1.15-2.79-2.25-5.59l-38.65,22.46q1.09,2.8,2.25,5.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M21.32,1021.38,60,998.92q-1.09-2.8-2.11-5.63l-38.65,22.46q1,2.82,2.11,5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M19.21,1015.75l38.65-22.46q-1.06-2.92-2-5.86l-38.66,22.46q1,2.94,2.05,5.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M17.16,1009.89l38.66-22.46c-.67-2-1.3-4-1.91-5.94L15.26,1004c.6,2,1.24,4,1.9,5.94",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M15.26,1004l38.65-22.46c-.62-2-1.21-4-1.77-6.08L13.48,997.87c.56,2,1.16,4,1.78,6.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M13.48,997.87l38.66-22.46c-.57-2-1.1-4.07-1.61-6.1L11.88,991.77c.5,2,1,4.07,1.6,6.1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M11.88,991.77l38.65-22.46c-.5-2-1-4-1.4-6L10.48,985.75c.43,2,.9,4,1.4,6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M10.48,985.75l38.65-22.46c-.44-2-.84-4-1.22-6L9.26,979.75q.56,3,1.22,6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M9.26,979.75l38.65-22.46c-.36-1.94-.7-3.88-1-5.81L8.25,973.94c.31,1.93.64,3.87,1,5.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M8.25,973.94l38.66-22.46c-.31-1.93-.58-3.86-.83-5.78L7.43,968.16c.24,1.92.52,3.85.82,5.78",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M7.43,968.16,46.08,945.7q-.34-2.82-.62-5.63L6.8,962.53q.27,2.81.63,5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M6.8,962.53l38.66-22.46q-.27-2.8-.45-5.6L6.36,956.94c.12,1.85.27,3.72.44,5.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M6.36,956.94,45,934.47c-.12-1.86-.2-3.71-.26-5.56L6.1,951.38c.05,1.84.14,3.7.26,5.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M6.1,951.38l38.65-22.47c0-1.73-.07-3.46-.07-5.19L6,946.19c0,1.72,0,3.45.07,5.19",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-43"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-38",
  d: "M111.79,1146.61l8.86-1.89-2.76-1.63L109.1,1145c.9.54,1.79,1.07,2.69,1.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M109.1,1145l8.79-1.93c-1.86-1.12-3.7-2.29-5.54-3.5l-8.65,2c1.79,1.18,3.59,2.31,5.4,3.41",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M103.7,1141.61l8.65-2q-2.89-1.9-5.74-4l-8.51,2.12q2.78,2,5.6,3.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M98.1,1137.75l8.51-2.12c-2-1.4-3.91-2.86-5.84-4.36l-8.37,2.22c1.89,1.47,3.78,2.89,5.7,4.26",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M92.4,1133.49l8.37-2.22c-2.09-1.62-4.15-3.3-6.19-5l-8.22,2.34q3,2.54,6,4.9",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M86.36,1128.59l8.22-2.34q-3.4-2.88-6.72-5.92l-8,2.49c2.15,2,4.34,3.91,6.54,5.77",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M79.82,1122.82l8-2.49q-3.75-3.45-7.39-7.13l-7.87,2.67q3.56,3.59,7.22,7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M72.6,1115.87l7.87-2.67q-4.45-4.47-8.71-9.25l-7.65,2.9q4.15,4.65,8.49,9",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M64.11,1106.85l7.65-2.9q-6.11-6.84-11.81-14.24L52.59,1093q5.55,7.2,11.52,13.89",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M52.59,1093l7.36-3.25a277.1,277.1,0,0,1-23.21-35.44L30,1058.4A271.55,271.55,0,0,0,52.59,1093",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M30,1058.4l6.79-4.13c-3.25-5.88-6.28-11.88-9.08-18l-6.56,4.57q4.09,8.88,8.85,17.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M21.1,1040.89l6.56-4.57q-2.73-5.94-5.16-12l-6.43,4.86q2.36,5.87,5,11.66",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M16.07,1029.23l6.43-4.86q-2-5-3.81-10.06l-6.34,5.11q1.74,4.92,3.72,9.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M12.35,1019.42l6.34-5.11c-1-2.89-2-5.8-2.92-8.7l-6.27,5.32q1.34,4.26,2.85,8.49",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M9.5,1010.93l6.27-5.32c-.84-2.69-1.64-5.37-2.38-8.06l-6.21,5.52q1.1,3.93,2.32,7.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M7.18,1003.07l6.21-5.52c-.7-2.54-1.35-5.09-2-7.62l-6.16,5.71q.89,3.71,1.91,7.43",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M5.27,995.64l6.16-5.71q-.86-3.57-1.57-7.11L3.74,988.7c.46,2.31,1,4.62,1.53,6.94",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M3.74,988.7l6.12-5.88c-.47-2.29-.89-4.58-1.28-6.86l-6.09,6c.38,2.23.79,4.46,1.25,6.69",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M2.49,982l6.09-6c-.37-2.23-.71-4.45-1-6.67l-6.07,6.22c.29,2.16.61,4.33,1,6.5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M1.51,975.51l6.07-6.22q-.44-3.25-.75-6.48l-6,6.38q.31,3.15.73,6.32",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M.78,969.19l6.05-6.38q-.31-3.21-.5-6.41l-6,6.54c.13,2.07.29,4.16.49,6.25",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M.29,962.94l6-6.54q-.2-3.2-.27-6.36l-6,6.69c0,2.06.13,4.13.25,6.21",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M0,956.73l6-6.69c0-1.29,0-2.57,0-3.85L0,953c0,1.24,0,2.5,0,3.75",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-45",
  points: "388.13 1230.79 159.3 1098.67 168.18 1090.26 397.01 1222.37 388.13 1230.79"
}), React.createElement("polygon", {
  className: "cls-46",
  points: "349.48 1253.25 120.65 1121.13 159.3 1098.67 388.13 1230.79 349.48 1253.25"
}), React.createElement("polygon", {
  className: "cls-47",
  points: "340.62 1255.14 111.79 1123.02 120.65 1121.13 349.48 1253.25 340.62 1255.14"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-48"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-49",
  d: "M400.4,1293.44l10.37-1.52-1.1.15-10.35,1.52,1.08-.15",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M399.32,1293.59l10.35-1.52a68.11,68.11,0,0,1-7.22.53l-10.17,1.5a67.19,67.19,0,0,0,7-.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M392.28,1294.1l10.17-1.5c-2.08,0-4.19,0-6.34-.16l-10,1.51q3.13.21,6.17.15",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M386.11,1294l10-1.51c-1.95-.13-3.94-.34-5.95-.63l-9.87,1.52q3,.42,5.82.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M380.29,1293.33l9.87-1.52c-1.9-.27-3.81-.61-5.75-1l-9.72,1.55q2.83.6,5.6,1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M374.69,1292.34l9.72-1.55c-1.81-.38-3.64-.83-5.48-1.33l-9.59,1.58c1.8.49,3.59.92,5.35,1.3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M369.34,1291l9.59-1.58c-1.78-.49-3.56-1-5.37-1.63l-9.45,1.62q2.64.88,5.23,1.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M364.11,1289.45l9.45-1.62q-2.65-.88-5.34-1.93l-9.32,1.67q2.63,1,5.21,1.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M358.9,1287.57l9.32-1.67c-1.74-.67-3.5-1.4-5.26-2.19l-9.19,1.73q2.58,1.14,5.13,2.13",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M353.77,1285.44l9.19-1.73q-2.65-1.17-5.33-2.5l-9.06,1.78c1.74.87,3.48,1.68,5.2,2.45",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M348.57,1283l9.06-1.78c-1.79-.89-3.58-1.83-5.39-2.82l-8.92,1.85q2.64,1.46,5.25,2.75",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M343.32,1280.24l8.92-1.85c-.92-.51-1.84-1-2.76-1.56l-8.86,1.89c.9.52,1.8,1,2.7,1.52",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-56"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-57",
  d: "M486.28,1248l6.45-8.26a54.8,54.8,0,0,1-23.64,17.7l-7,8.7A56.1,56.1,0,0,0,486.28,1248",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M462,1266.18l7-8.7a56.28,56.28,0,0,1-8,2.4l-7.25,8.77a57.82,57.82,0,0,0,8.22-2.47",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M453.82,1268.65l7.25-8.77a60.57,60.57,0,0,1-6.71,1.1l-7.42,8.79a61.3,61.3,0,0,0,6.88-1.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M446.94,1269.77l7.42-8.79q-3,.32-6.05.36l-7.58,8.8q3.16,0,6.21-.37",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M440.73,1270.14l7.58-8.8c-1.79,0-3.61,0-5.45-.14l-7.71,8.8c1.89.12,3.75.17,5.58.14",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M435.15,1270l7.71-8.8c-1.72-.1-3.47-.27-5.24-.5l-7.84,8.78c1.81.24,3.6.41,5.37.52",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M429.78,1269.48l7.84-8.78c-1.69-.23-3.4-.5-5.13-.84l-8,8.76c1.78.35,3.53.63,5.27.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M424.51,1268.62l8-8.76c-1.6-.31-3.21-.67-4.84-1.08l-8.1,8.74c1.67.42,3.33.78,5,1.1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M419.55,1267.52l8.1-8.74q-2.41-.62-4.86-1.36l-8.22,8.7c1.67.52,3.34,1,5,1.4",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M414.57,1266.12l8.22-8.7q-2.35-.72-4.76-1.59l-8.34,8.67c1.64.59,3.26,1.13,4.88,1.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M409.69,1264.5l8.34-8.67c-1.58-.56-3.17-1.18-4.77-1.83l-8.47,8.61c1.65.68,3.28,1.3,4.9,1.89",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M404.79,1262.61l8.47-8.61c-1.58-.65-3.17-1.35-4.78-2.08l-8.58,8.56q2.46,1.14,4.89,2.13",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M399.9,1260.48l8.58-8.56c-1.59-.74-3.2-1.52-4.81-2.34l-8.71,8.5c1.66.85,3.3,1.65,4.94,2.4",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M395,1258.08l8.71-8.5q-2.42-1.23-4.86-2.6l-8.83,8.44q2.5,1.39,5,2.66",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M390,1255.42l8.83-8.44-1.8-1-8.88,8.41,1.85,1.05",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-58"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-57",
  d: "M431.31,1284.85,470,1262.39a55.39,55.39,0,0,1-9.31,4.3L422,1289.15a54.67,54.67,0,0,0,9.31-4.3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M422,1289.15l38.66-22.46a57.37,57.37,0,0,1-8,2.21L414,1291.37a59.05,59.05,0,0,0,8-2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M414,1291.37l38.65-22.47a59.44,59.44,0,0,1-6.63,1l-38.65,22.47a64.5,64.5,0,0,0,6.63-1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M407.34,1292.33,446,1269.86q-2.92.27-6,.29l-38.65,22.46q3,0,6-.28",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M401.38,1292.61,440,1270.15q-2.65,0-5.4-.18L396,1292.43q2.73.19,5.4.18",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M396,1292.43,434.63,1270c-1.69-.12-3.39-.29-5.12-.52l-38.65,22.46c1.73.23,3.43.4,5.12.52",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M390.86,1291.91l38.65-22.46c-1.66-.23-3.34-.5-5-.83l-38.65,22.46c1.69.33,3.37.61,5,.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M385.83,1291.08l38.65-22.46c-1.56-.31-3.13-.66-4.72-1L381.11,1290c1.59.4,3.16.75,4.72,1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M381.11,1290l38.65-22.46q-2.36-.58-4.75-1.31l-38.65,22.46q2.4.72,4.75,1.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M376.36,1288.72,415,1266.26c-1.52-.46-3.06-1-4.6-1.51l-38.66,22.46q2.33.82,4.61,1.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M371.75,1287.21l38.66-22.46q-2.31-.81-4.65-1.75l-38.65,22.47q2.34.93,4.64,1.74",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M367.11,1285.47,405.76,1263q-2.28-.91-4.6-2l-38.65,22.47c1.54.69,3.08,1.34,4.6,2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M362.51,1283.52l38.65-22.47q-2.31-1-4.66-2.19l-38.65,22.46q2.34,1.15,4.66,2.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M357.85,1281.32l38.65-22.46q-2.34-1.17-4.71-2.44l-38.65,22.46c1.58.85,3.15,1.67,4.71,2.44",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M353.14,1278.88l38.65-22.46c-1.21-.66-2.43-1.34-3.66-2.05l-38.65,22.46c1.22.71,2.44,1.39,3.66,2.05",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-59"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-44",
  d: "M503.51,1188.63l6-6.79,0,2.46-6,6.86c0-.84,0-1.68,0-2.53",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M503.48,1191.16l6-6.86c0,2.09-.13,4.14-.25,6.15l-6,7q.19-3.09.26-6.3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M503.22,1197.46l6-7q-.21,3.18-.55,6.22l-6,7.17c.24-2.08.42-4.21.56-6.38",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M502.66,1203.84l6-7.17c-.23,2.1-.52,4.16-.85,6.17l-6.07,7.32q.51-3.09.87-6.32",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M501.79,1210.16l6.07-7.32q-.56,3.29-1.27,6.42l-6.1,7.48c.49-2.13.92-4.33,1.3-6.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M500.49,1216.74l6.1-7.48c-.54,2.32-1.14,4.58-1.81,6.76l-6.15,7.65c.69-2.23,1.31-4.55,1.86-6.93",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M498.63,1223.67l6.15-7.65q-1.17,3.78-2.6,7.27l-6.22,7.84c1-2.39,1.87-4.87,2.67-7.46",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M496,1231.13l6.22-7.84a75.65,75.65,0,0,1-4.08,8.43l-6.32,8a76.8,76.8,0,0,0,4.18-8.64",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M491.78,1239.77l6.32-8a66.53,66.53,0,0,1-5.37,8.07l-6.45,8.25a66,66,0,0,0,5.5-8.27",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-60"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-40",
  d: "M464.86,1211.09l38.65-22.46v.33l-38.66,22.46c0-.11,0-.22,0-.33",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M464.85,1211.42,503.51,1189c0,1.88-.06,3.74-.13,5.56L464.72,1217c.08-1.82.12-3.68.13-5.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M464.72,1217l38.66-22.46c-.08,1.84-.19,3.65-.34,5.43l-38.65,22.46c.14-1.78.26-3.59.33-5.43",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M464.39,1222.41,503,1200c-.15,1.87-.34,3.72-.57,5.53l-38.65,22.46q.33-2.71.57-5.53",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M463.82,1227.94l38.65-22.46q-.36,2.8-.82,5.5L463,1233.44c.32-1.8.59-3.63.83-5.5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M463,1233.44,501.65,1211c-.34,1.91-.71,3.79-1.13,5.62l-38.66,22.47c.42-1.84.8-3.71,1.13-5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M461.86,1239.07l38.66-22.47q-.69,3-1.53,5.88l-38.65,22.46c.55-1.91,1.07-3.86,1.52-5.87",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M460.34,1244.94,499,1222.48c-.61,2.08-1.28,4.09-2,6L458.33,1251q1.08-2.92,2-6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M458.33,1251,497,1228.53q-1.26,3.39-2.76,6.54l-38.65,22.46q1.49-3.13,2.76-6.54",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M455.57,1257.53l38.65-22.46a72.94,72.94,0,0,1-4.34,7.86l-38.65,22.46a72,72,0,0,0,4.34-7.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M451.23,1265.39l38.65-22.46A58.59,58.59,0,0,1,470,1262.39l-38.66,22.46a58.44,58.44,0,0,0,19.92-19.46",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-61"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-41",
  d: "M453.15,1214.61l11.71-3.52c0,1.81-.05,3.6-.11,5.36l-11.7,3.38c.06-1.72.1-3.46.1-5.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M453.05,1219.83l11.7-3.38q-.12,2.91-.34,5.71l-11.69,3.25q.21-2.75.33-5.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M452.72,1225.41l11.69-3.25q-.24,3-.6,5.82l-11.68,3.1c.24-1.86.43-3.75.59-5.67",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M452.13,1231.08l11.68-3.1q-.37,2.94-.87,5.77l-11.65,3q.48-2.76.84-5.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M451.29,1236.7l11.65-3q-.53,3-1.2,5.84l-11.62,2.81q.64-2.79,1.17-5.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M450.12,1242.4l11.62-2.81c-.49,2.1-1,4.14-1.64,6.12l-11.58,2.66c.59-1.93,1.12-3.93,1.6-6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M448.52,1248.37l11.58-2.66q-1,3.27-2.17,6.33l-11.53,2.5c.77-2,1.47-4,2.12-6.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M446.4,1254.54l11.53-2.5q-1.38,3.57-3,6.84l-11.45,2.33q1.59-3.2,2.94-6.67",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M443.46,1261.21l11.45-2.33a71.12,71.12,0,0,1-4.69,8.06l-11.34,2.13a71.31,71.31,0,0,0,4.58-7.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M438.88,1269.07l11.34-2.13c-9.48,14-23.08,22.58-39.45,25l-10.37,1.52c16-2.34,29.24-10.72,38.48-24.37",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-62",
  points: "44.68 900.14 47 83.03 58.7 79.51 56.38 896.63 44.68 900.14"
}), React.createElement("polygon", {
  className: "cls-63",
  points: "6.03 922.6 8.35 105.49 47 83.03 44.68 900.14 6.03 922.6"
}), React.createElement("polygon", {
  className: "cls-64",
  points: "0 929.39 2.32 112.28 8.35 105.49 6.03 922.6 0 929.39"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-65"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-44",
  d: "M2.32,135.86l6-6.79c0-.84,0-1.69,0-2.52l-6,6.85c0,.82,0,1.64,0,2.46",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M2.34,133.4l6-6.85c0-2.14.13-4.25.26-6.31l-6,7q-.19,3-.26,6.15",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M2.6,127.25l6-7q.21-3.26.56-6.37l-6,7.16q-.35,3-.54,6.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M3.14,121l6-7.16q.36-3.24.88-6.33L4,114.87c-.34,2-.62,4.06-.86,6.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M4,114.87l6.07-7.33c.37-2.25.81-4.44,1.3-6.58l-6.11,7.49c-.47,2.08-.9,4.22-1.26,6.42",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M5.26,108.45,11.37,101q.83-3.57,1.86-6.93l-6.15,7.66c-.68,2.18-1.28,4.43-1.82,6.76",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M7.08,101.69,13.23,94c.79-2.59,1.68-5.07,2.66-7.46L9.68,94.41c-1,2.33-1.82,4.75-2.6,7.28",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M9.68,94.41l6.21-7.84a76.8,76.8,0,0,1,4.18-8.64l-6.31,8a73.93,73.93,0,0,0-4.08,8.43",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M13.76,86l6.31-8a66.39,66.39,0,0,1,5.51-8.27l-6.45,8.25A64.26,64.26,0,0,0,13.76,86",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-66"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-41",
  d: "M47,106.61l11.7-3.51c0-1.77,0-3.51.11-5.23l-11.7,3.39C47,103,47,104.8,47,106.61",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M47.11,101.26l11.7-3.39c.07-1.89.18-3.75.33-5.57L47.45,95.54c-.15,1.87-.27,3.78-.34,5.72",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M47.45,95.54,59.14,92.3c.15-1.93.35-3.82.58-5.67L48,89.72q-.36,2.85-.59,5.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M48,89.72l11.68-3.09c.24-1.92.52-3.79.85-5.63L48.91,84q-.49,2.82-.87,5.76",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M48.91,84l11.66-3q.51-2.91,1.17-5.7L50.11,78.11C49.66,80,49.27,82,48.91,84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M50.11,78.11,61.74,75.3c.47-2,1-4,1.59-6L51.75,72c-.6,2-1.15,4-1.64,6.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M51.75,72l11.58-2.66q1-3.18,2.13-6.17l-11.53,2.5Q52.75,68.72,51.75,72",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M53.93,65.66l11.53-2.5q1.35-3.48,2.94-6.67L56.94,58.82q-1.63,3.27-3,6.84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M56.94,58.82,68.4,56.49A68.27,68.27,0,0,1,73,48.63L61.64,50.76a72.7,72.7,0,0,0-4.7,8.06",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M61.64,50.76,73,48.63c9.24-13.66,22.51-22,38.48-24.37l-10.37,1.52c-16.37,2.39-30,11-39.45,25",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-67"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-40",
  d: "M8.34,129.07,47,106.61v-.33L8.35,128.74c0,.11,0,.22,0,.33",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M8.35,128.74,47,106.28c0-1.88,0-3.73.13-5.56L8.48,123.18c-.08,1.83-.12,3.68-.13,5.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M8.48,123.18l38.65-22.46c.08-1.84.19-3.65.34-5.42L8.81,117.76c-.14,1.78-.26,3.59-.33,5.42",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M8.81,117.76,47.47,95.3q.22-2.82.57-5.54L9.39,112.22q-.35,2.72-.58,5.54",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M9.39,112.22,48,89.76c.23-1.87.51-3.7.82-5.5L10.21,106.73q-.48,2.68-.82,5.49",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M10.21,106.73,48.86,84.26q.49-2.88,1.13-5.62L11.34,101.1q-.63,2.75-1.13,5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M11.34,101.1,50,78.64q.69-3,1.53-5.88L12.87,95.23q-.84,2.85-1.53,5.87",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M12.87,95.23,51.52,72.76q.91-3.12,2-6.05L14.88,89.17q-1.1,2.94-2,6.06",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M14.88,89.17,53.53,66.71q1.26-3.4,2.76-6.54L17.63,82.63q-1.48,3.15-2.75,6.54",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M17.63,82.63,56.29,60.17a71.36,71.36,0,0,1,4.33-7.87L22,74.77a72.94,72.94,0,0,0-4.34,7.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-57",
  d: "M22,74.77,60.62,52.3A58.68,58.68,0,0,1,80.54,32.85L41.89,55.31A58.44,58.44,0,0,0,22,74.77",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-68"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-49",
  d: "M101.09,25.78l10.37-1.52,1.07-.15-10.34,1.51-1.1.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M102.19,25.62l10.34-1.51a65,65,0,0,1,7-.51l-10.17,1.5a68.13,68.13,0,0,0-7.22.52",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M109.41,25.1l10.17-1.5q3-.06,6.17.15l-10,1.51q-3.23-.23-6.34-.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M115.75,25.26l10-1.51q2.87.2,5.81.61l-9.86,1.52c-2-.28-4-.49-6-.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M121.7,25.88l9.86-1.52q2.77.41,5.61,1l-9.72,1.54q-2.91-.6-5.75-1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M127.45,26.9l9.72-1.54q2.64.55,5.34,1.3l-9.58,1.58c-1.85-.51-3.67-.95-5.48-1.34",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M132.93,28.24l9.58-1.58q2.6.7,5.23,1.58l-9.45,1.62q-2.7-.9-5.36-1.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M138.29,29.86l9.45-1.62c1.73.58,3.46,1.2,5.22,1.88l-9.32,1.67q-2.7-1-5.35-1.93",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M143.64,31.79,153,30.12c1.69.66,3.4,1.38,5.13,2.14L148.9,34q-2.66-1.17-5.26-2.19",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M148.9,34l9.19-1.72c1.72.76,3.45,1.58,5.19,2.44l-9.06,1.78c-1.78-.88-3.56-1.72-5.32-2.5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M154.22,36.48l9.06-1.78c1.74.87,3.49,1.78,5.25,2.75l-8.92,1.85c-1.81-1-3.6-1.93-5.39-2.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M159.61,39.3l8.92-1.85c.9.49,1.79,1,2.69,1.52l-8.85,1.89-2.76-1.56",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-69"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-57",
  d: "M41.89,55.31,80.54,32.85a55.44,55.44,0,0,1,9.31-4.31L51.2,51a55.39,55.39,0,0,0-9.31,4.3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M51.2,51,89.85,28.54a58.77,58.77,0,0,1,8-2.21L59.24,48.79a58.79,58.79,0,0,0-8,2.22",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M59.24,48.79,97.89,26.33a64.5,64.5,0,0,1,6.63-1L65.86,47.83a64.71,64.71,0,0,0-6.62,1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M65.86,47.83l38.66-22.46q2.92-.27,6-.28L71.83,47.55c-2,0-4,.1-6,.28",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M71.83,47.55l38.65-22.46c1.77,0,3.58.05,5.4.18L77.23,47.73q-2.74-.19-5.4-.18",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M77.23,47.73l38.65-22.46c1.69.11,3.39.29,5.12.52L82.34,48.25c-1.72-.23-3.43-.41-5.11-.52",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M82.34,48.25,121,25.79c1.66.22,3.34.5,5,.83L87.38,49.08c-1.7-.33-3.38-.61-5-.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M87.38,49.08,126,26.62c1.56.3,3.13.65,4.71,1L92.09,50.13c-1.58-.4-3.16-.75-4.71-1.05",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M92.09,50.13l38.65-22.47c1.57.4,3.16.83,4.76,1.32L96.84,51.44c-1.59-.48-3.18-.92-4.75-1.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M96.84,51.44,135.5,29q2.28.69,4.6,1.5L101.45,52.94c-1.55-.54-3.08-1-4.61-1.5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M101.45,52.94,140.1,30.48c1.54.54,3.08,1.12,4.64,1.75L106.09,54.69c-1.56-.62-3.11-1.21-4.64-1.75",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M106.09,54.69l38.65-22.46q2.3.92,4.6,2L110.69,56.64c-1.54-.69-3.08-1.34-4.6-2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M110.69,56.64l38.65-22.46q2.32,1,4.66,2.19L115.35,58.84c-1.56-.78-3.12-1.51-4.66-2.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M115.35,58.84,154,36.37q2.34,1.17,4.71,2.44L120.06,61.28q-2.37-1.29-4.71-2.44",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M120.06,61.28l38.65-22.47c1.21.66,2.43,1.34,3.66,2L123.71,63.32c-1.22-.7-2.44-1.39-3.65-2",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-70"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-57",
  d: "M19.13,77.91l6.45-8.25A56.12,56.12,0,0,1,49.82,51.51l-7,8.71A54.66,54.66,0,0,0,19.13,77.91",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-49",
  d: "M42.77,60.22l7-8.71A58.71,58.71,0,0,1,58,49.05l-7.25,8.76a57.22,57.22,0,0,0-8,2.41",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-50",
  d: "M50.79,57.81,58,49.05a61.3,61.3,0,0,1,6.88-1.12L57.5,56.72a60.56,60.56,0,0,0-6.71,1.09",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-51",
  d: "M57.5,56.72l7.42-8.79q3-.33,6.21-.37l-7.58,8.8q-3.07,0-6,.36",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-52",
  d: "M63.55,56.36l7.58-8.8c1.83,0,3.69,0,5.58.13L69,56.49c-1.85-.11-3.66-.16-5.45-.13",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-53",
  d: "M69,56.49l7.71-8.8c1.77.11,3.56.29,5.37.53L74.24,57c-1.77-.23-3.52-.4-5.24-.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-54",
  d: "M74.24,57l7.84-8.78c1.74.22,3.49.51,5.26.85l-8,8.77q-2.59-.51-5.13-.84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-55",
  d: "M79.37,57.84l8-8.77q2.46.48,5,1.11l-8.1,8.74c-1.62-.41-3.24-.77-4.83-1.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M84.2,58.92l8.1-8.74q2.48.63,5,1.39l-8.22,8.71q-2.46-.77-4.87-1.36",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M89.07,60.28l8.22-8.71q2.42.75,4.87,1.63l-8.34,8.66q-2.4-.86-4.75-1.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M93.82,61.86l8.34-8.66q2.43.87,4.9,1.88L98.59,63.7q-2.4-1-4.77-1.84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M98.59,63.7l8.47-8.62q2.43,1,4.89,2.13l-8.58,8.57c-1.6-.74-3.2-1.43-4.78-2.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M103.37,65.78,112,57.21c1.64.76,3.28,1.56,4.94,2.4l-8.71,8.5c-1.61-.82-3.22-1.6-4.81-2.33",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M108.18,68.11l8.71-8.5q2.48,1.26,5,2.66L113,70.71q-2.43-1.36-4.85-2.6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M113,70.71l8.83-8.44c.62.34,1.24.7,1.85,1l-8.87,8.41-1.81-1",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-64",
  points: "505.82 347.93 511.85 341.14 509.54 1158.25 503.51 1165.04 505.82 347.93"
}), React.createElement("polygon", {
  className: "cls-47",
  points: "162.37 17.27 171.22 15.38 400.06 147.5 391.2 149.39 162.37 17.27"
}), React.createElement("polygon", {
  className: "cls-63",
  points: "467.17 370.39 505.82 347.93 503.51 1165.04 464.86 1187.51 467.17 370.39"
}), React.createElement("polygon", {
  className: "cls-46",
  points: "123.71 39.74 162.37 17.27 391.2 149.39 352.55 171.85 123.71 39.74"
}), React.createElement("polygon", {
  className: "cls-62",
  points: "455.47 373.91 467.17 370.39 464.86 1187.51 453.15 1191.02 455.47 373.91"
}), React.createElement("polygon", {
  className: "cls-45",
  points: "114.84 48.15 123.71 39.74 352.55 171.85 343.67 180.27 114.84 48.15"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-71"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-38",
  d: "M391.2,173l8.86-1.9c.89.52,1.79,1,2.68,1.59L394,174.6q-1.38-.82-2.76-1.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M394,174.6l8.78-1.93q2.73,1.65,5.41,3.42l-8.65,2q-2.76-1.81-5.54-3.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M399.5,178.11l8.65-2q2.82,1.86,5.6,3.85l-8.51,2.12q-2.85-2-5.74-3.95",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M405.24,182.06l8.51-2.12q2.87,2.07,5.7,4.26l-8.37,2.23c-1.93-1.51-3.88-3-5.84-4.37",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M411.08,186.43l8.37-2.23c2,1.58,4,3.22,6,4.9l-8.22,2.35q-3.06-2.59-6.19-5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M417.27,191.45l8.22-2.35c2.2,1.87,4.39,3.79,6.54,5.77l-8,2.5q-3.32-3-6.72-5.92",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M424,197.37l8-2.5q3.66,3.38,7.22,6.95l-7.86,2.67q-3.64-3.66-7.4-7.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M431.39,204.49l7.86-2.67q4.33,4.37,8.49,9l-7.65,2.89q-4.26-4.77-8.7-9.25",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M440.09,213.74l7.65-2.89q6,6.68,11.52,13.89L451.91,228q-5.7-7.38-11.82-14.25",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M451.91,228l7.35-3.25a271.44,271.44,0,0,1,22.64,34.55l-6.79,4.13A277.62,277.62,0,0,0,451.91,228",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M475.11,263.42l6.79-4.13q4.74,8.63,8.85,17.51l-6.56,4.57c-2.8-6.07-5.83-12.07-9.08-17.95",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M484.19,281.37l6.56-4.57q2.67,5.81,5,11.67l-6.43,4.86q-2.43-6-5.16-12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M489.35,293.33l6.43-4.86q2,4.89,3.73,9.81l-6.34,5.11q-1.8-5.06-3.82-10.06",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M493.17,303.39l6.34-5.11q1.5,4.23,2.84,8.49l-6.27,5.32c-.91-2.91-1.89-5.81-2.91-8.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M496.08,312.09l6.27-5.32c.82,2.62,1.6,5.24,2.32,7.86l-6.21,5.52c-.74-2.69-1.54-5.38-2.38-8.06",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M498.46,320.15l6.21-5.52q1,3.72,1.91,7.44l-6.16,5.7c-.6-2.54-1.26-5.08-2-7.62",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M500.42,327.77l6.16-5.7q.84,3.46,1.54,6.93L502,334.88c-.49-2.36-1-4.73-1.58-7.11",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M502,334.88l6.12-5.88c.45,2.23.87,4.46,1.24,6.69l-6.09,6.05c-.38-2.28-.81-4.57-1.27-6.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M503.27,341.74l6.09-6.05q.56,3.26,1,6.5l-6.06,6.22c-.3-2.21-.63-4.44-1-6.67",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M504.28,348.41l6.06-6.22c.28,2.12.53,4.22.73,6.32L505,354.89q-.31-3.22-.74-6.48",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M505,354.89l6.05-6.38c.2,2.09.37,4.18.49,6.25l-6,6.54c-.13-2.13-.3-4.26-.51-6.41",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M505.53,361.3l6-6.54c.13,2.08.21,4.15.26,6.21l-6,6.7c-.05-2.11-.13-4.24-.26-6.37",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-44",
  d: "M505.79,367.67l6-6.7c0,1.26,0,2.51,0,3.76l-6,6.79c0-1.28,0-2.57,0-3.85",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-72"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-4",
  d: "M352.55,195.44,391.2,173l1.13.65L353.68,196.1l-1.13-.66",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M353.68,196.1l38.65-22.47q2.44,1.44,4.87,3l-38.66,22.46q-2.42-1.54-4.86-3",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M358.54,199.08l38.66-22.46q2.44,1.56,4.88,3.22l-38.65,22.47q-2.43-1.67-4.89-3.23",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M363.43,202.31l38.65-22.47q2.52,1.72,5,3.56l-38.65,22.46c-1.66-1.22-3.32-2.4-5-3.55",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M368.43,205.86l38.65-22.46q2.55,1.88,5.05,3.85l-38.65,22.46c-1.67-1.32-3.36-2.6-5.05-3.85",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M373.48,209.71l38.65-22.46q2.58,2,5.12,4.18L378.6,213.89c-1.7-1.43-3.4-2.82-5.12-4.18",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M378.6,213.89l38.65-22.46q2.58,2.17,5.11,4.46l-38.65,22.46c-1.69-1.52-3.4-3-5.11-4.46",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M383.71,218.35l38.65-22.46c1.7,1.53,3.39,3.1,5.05,4.7l-38.65,22.46q-2.5-2.4-5.05-4.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M388.76,223.05l38.65-22.46c1.64,1.56,3.25,3.16,4.85,4.79l-38.65,22.46c-1.6-1.63-3.22-3.22-4.85-4.79",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M393.61,227.84l38.65-22.46q2.39,2.43,4.71,4.93l-38.66,22.46q-2.32-2.51-4.7-4.93",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M398.31,232.77,437,210.31q2.26,2.44,4.47,5l-38.65,22.46q-2.22-2.52-4.48-5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M402.79,237.73l38.65-22.46q2.25,2.56,4.44,5.2l-38.65,22.46q-2.19-2.64-4.44-5.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M407.23,242.93l38.65-22.46q2.25,2.7,4.44,5.48l-38.65,22.46q-2.19-2.78-4.44-5.48",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M411.67,248.41,450.32,226c1.73,2.2,3.44,4.44,5.11,6.71l-38.65,22.46c-1.68-2.27-3.38-4.5-5.11-6.71",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M416.78,255.12l38.65-22.46q3.75,5.09,7.28,10.37L424.06,265.5q-3.54-5.29-7.28-10.38",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M424.06,265.5,462.71,243q4.46,6.66,8.53,13.59l-38.66,22.46c-2.71-4.61-5.56-9.15-8.52-13.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M432.58,279.08l38.66-22.46q2.94,5,5.67,10.11l-38.66,22.46q-2.73-5.12-5.67-10.11",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M438.25,289.19l38.66-22.46q1.83,3.42,3.56,6.9l-38.65,22.46c-1.16-2.31-2.34-4.61-3.57-6.9",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M441.82,296.09l38.65-22.46c1,2,2,4,2.94,6.07l-38.65,22.46c-1-2-1.94-4.06-2.94-6.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M444.76,302.16l38.65-22.46c.86,1.84,1.71,3.69,2.53,5.55l-38.66,22.46c-.82-1.85-1.66-3.71-2.52-5.55",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M447.28,307.71l38.66-22.46q1.2,2.73,2.35,5.48l-38.66,22.46q-1.14-2.74-2.35-5.48",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M449.63,313.19l38.66-22.46q1.15,2.79,2.24,5.58l-38.65,22.47q-1.1-2.8-2.25-5.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M451.88,318.78l38.65-22.47q1.1,2.82,2.12,5.64L454,324.41q-1-2.82-2.11-5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M454,324.41,492.65,302c.7,1.95,1.39,3.9,2,5.86L456,330.27q-1-2.94-2.05-5.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M456,330.27l38.65-22.46q1,3,1.91,5.94l-38.66,22.46c-.6-2-1.24-4-1.9-5.94",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M457.94,336.21l38.66-22.46c.62,2,1.21,4.05,1.77,6.08l-38.65,22.46c-.56-2-1.16-4.05-1.78-6.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M459.72,342.29l38.65-22.46q.86,3,1.6,6.1l-38.65,22.46c-.5-2-1-4.07-1.6-6.1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M461.32,348.39,500,325.93q.75,3,1.41,6l-38.66,22.46q-.64-3-1.4-6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M462.72,354.41,501.38,332q.64,3,1.22,6l-38.66,22.46q-.56-3-1.22-6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M463.94,360.41,502.6,338c.36,1.94.7,3.88,1,5.81L465,366.23c-.31-1.94-.64-3.88-1-5.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M465,366.23l38.65-22.47c.3,1.93.58,3.86.82,5.78L465.77,372c-.24-1.92-.52-3.84-.82-5.77",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M465.77,372l38.65-22.46q.36,2.82.63,5.63L466.4,377.63c-.18-1.87-.39-3.74-.63-5.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M466.4,377.63l38.65-22.46q.27,2.81.44,5.6l-38.65,22.46c-.12-1.86-.26-3.72-.44-5.6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M466.84,383.23l38.65-22.46c.12,1.86.21,3.71.26,5.56L467.1,388.79c-.05-1.84-.14-3.7-.26-5.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M467.1,388.79l38.65-22.46c.06,1.74.08,3.46.08,5.19L467.17,394c0-1.72,0-3.45-.07-5.19",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-73"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-4",
  d: "M343.67,203.85l8.88-8.41c1.06.61,2.11,1.24,3.17,1.88l-9,8.36q-1.53-.93-3.09-1.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M346.76,205.68l9-8.36q2.49,1.52,5,3.15l-9.08,8.28c-1.6-1.05-3.22-2.08-4.85-3.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M351.61,208.75l9.08-8.28q2.38,1.58,4.76,3.24l-9.2,8.21c-1.53-1.09-3.08-2.14-4.64-3.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M356.25,211.92l9.2-8.21c1.56,1.1,3.1,2.23,4.64,3.39l-9.3,8.13q-2.27-1.71-4.54-3.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M360.79,215.23l9.3-8.13c1.37,1,2.72,2.08,4.07,3.15l-9.41,8.05q-2-1.58-4-3.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M364.75,218.3l9.41-8.05c1.3,1,2.58,2.09,3.86,3.16l-9.5,8c-1.25-1-2.5-2.07-3.77-3.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M368.52,221.38l9.5-8q1.71,1.43,3.4,2.91l-9.59,7.89q-1.65-1.44-3.31-2.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M371.83,224.21l9.59-7.89c.94.82,1.88,1.66,2.82,2.51l-9.66,7.84c-.91-.83-1.83-1.65-2.75-2.46",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M374.58,226.67l9.66-7.84c.94.85,1.87,1.71,2.8,2.58l-9.73,7.77c-.9-.85-1.81-1.68-2.73-2.51",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M377.31,229.18l9.73-7.77c.84.79,1.67,1.59,2.5,2.39l-9.79,7.72c-.81-.79-1.62-1.57-2.44-2.34",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M379.75,231.52l9.79-7.72,2,1.94-9.84,7.66c-.64-.63-1.28-1.26-1.93-1.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M381.68,233.4l9.84-7.66,2,2-9.88,7.62-1.91-1.92",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M383.59,235.32l9.88-7.62c.65.66,1.3,1.33,1.94,2l-9.93,7.56-1.89-1.94",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M385.48,237.26l9.93-7.56c.64.66,1.28,1.33,1.91,2l-10,7.52-1.86-2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M387.34,239.23l10-7.52,1.49,1.6-10,7.48-1.46-1.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M388.8,240.79l10-7.48,1.48,1.62-10.05,7.44-1.44-1.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-20",
  d: "M390.24,242.37l10.05-7.44,1.47,1.64L391.67,244c-.47-.54-.95-1.07-1.43-1.6",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-21",
  d: "M391.67,244l10.09-7.4c.49.55,1,1.1,1.46,1.66l-10.13,7.35c-.47-.54-.94-1.08-1.42-1.61",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-22",
  d: "M393.09,245.58l10.13-7.35,1.45,1.67-10.17,7.31c-.46-.54-.93-1.09-1.41-1.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-23",
  d: "M394.5,247.21l10.17-7.31c.46.53.92,1.07,1.37,1.62l-10.19,7.27-1.35-1.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-24",
  d: "M395.85,248.79,406,241.52l1.32,1.57-10.23,7.23-1.28-1.53",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-25",
  d: "M397.13,250.32l10.23-7.23c.44.52.87,1,1.31,1.58l-10.26,7.2-1.28-1.55",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-26",
  d: "M398.41,251.87l10.26-7.2,1.29,1.6-10.29,7.16-1.26-1.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-27",
  d: "M399.67,253.43,410,246.27l1.29,1.61L400.92,255c-.41-.53-.83-1.05-1.25-1.57",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-28",
  d: "M400.92,255l10.33-7.12,1.27,1.62-10.36,7.08c-.41-.53-.82-1.06-1.24-1.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M402.16,256.58l10.36-7.08,1.4,1.82-10.39,7-1.37-1.77",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-30",
  d: "M403.53,258.35l10.39-7c.5.65,1,1.31,1.49,2l-10.43,7-1.45-1.92",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-31",
  d: "M405,260.27l10.43-7,1.48,2-10.47,6.94c-.47-.65-.95-1.29-1.44-1.94",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-32",
  d: "M406.42,262.21l10.47-6.94c.49.67,1,1.34,1.46,2l-10.5,6.89-1.43-2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-33",
  d: "M407.85,264.16l10.5-6.89,1.44,2-10.54,6.84c-.46-.66-.93-1.32-1.4-2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-34",
  d: "M409.25,266.13l10.54-6.84c.78,1.1,1.55,2.21,2.31,3.32l-10.59,6.76c-.74-1.09-1.5-2.17-2.26-3.24",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-35",
  d: "M411.51,269.37l10.59-6.76c1,1.43,1.95,2.86,2.9,4.31l-10.66,6.65q-1.39-2.11-2.83-4.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-36",
  d: "M414.34,273.57,425,266.92q3.94,6,7.59,12.18l-10.85,6.35q-3.54-6-7.4-11.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-35",
  d: "M421.74,285.45l10.85-6.35q1.21,2.06,2.38,4.12l-10.91,6.25q-1.14-2-2.32-4",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-34",
  d: "M424.06,289.47,435,283.22c.5.88,1,1.75,1.47,2.63L425.5,292c-.48-.85-.95-1.71-1.44-2.56",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-33",
  d: "M425.5,292l10.94-6.18q.74,1.32,1.44,2.64l-11,6.12c-.46-.86-.93-1.72-1.4-2.58",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-32",
  d: "M426.9,294.61l11-6.12c.48.89.95,1.77,1.41,2.66l-11,6.05-1.38-2.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-31",
  d: "M428.28,297.2l11-6.05c.37.71.74,1.42,1.1,2.13l-11,6c-.35-.7-.71-1.39-1.07-2.08",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-30",
  d: "M429.35,299.28l11-6c.33.62.65,1.25,1,1.88l-11.06,5.95c-.31-.61-.62-1.22-.94-1.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M430.29,301.11l11.06-5.95c.32.63.63,1.26.94,1.89L431.2,303c-.3-.61-.61-1.22-.91-1.84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-28",
  d: "M431.2,303l11.09-5.9c.32.63.62,1.26.93,1.89l-11.11,5.86c-.3-.61-.6-1.23-.91-1.85",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-27",
  d: "M432.11,304.8l11.11-5.86.91,1.9L433,306.66l-.89-1.86",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-26",
  d: "M433,306.66l11.13-5.82.9,1.91-11.16,5.76-.87-1.85",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-25",
  d: "M433.87,308.51,445,302.75c.29.62.58,1.24.86,1.86l-11.18,5.72c-.28-.61-.55-1.21-.84-1.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-24",
  d: "M434.71,310.33l11.18-5.72.84,1.86-11.2,5.67c-.27-.6-.54-1.21-.82-1.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-23",
  d: "M435.53,312.14l11.2-5.67c.28.62.55,1.24.82,1.86L436.34,314l-.81-1.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-22",
  d: "M436.34,314l11.21-5.63q.42.93.81,1.86l-11.23,5.59c-.27-.61-.53-1.22-.79-1.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-21",
  d: "M437.13,315.78l11.23-5.59c.27.63.54,1.25.8,1.87L437.9,317.6c-.26-.61-.51-1.22-.77-1.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-20",
  d: "M437.9,317.6l11.26-5.54.78,1.87-11.28,5.49c-.25-.61-.5-1.21-.76-1.82",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M438.66,319.42l11.28-5.49c.29.71.58,1.42.86,2.13l-11.3,5.43q-.4-1-.84-2.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-18",
  d: "M439.5,321.49l11.3-5.43c.3.73.59,1.47.88,2.21l-11.32,5.38c-.28-.72-.57-1.44-.86-2.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-17",
  d: "M440.36,323.65l11.32-5.38c.29.74.58,1.48.86,2.22l-11.34,5.33-.84-2.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-16",
  d: "M441.2,325.82l11.34-5.33c.28.74.56,1.48.83,2.22L442,328l-.81-2.16",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-15",
  d: "M442,328l11.36-5.27q.42,1.11.81,2.22l-11.38,5.22c-.26-.72-.52-1.45-.79-2.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-14",
  d: "M442.8,330.15l11.38-5.22c.32.89.64,1.78.95,2.68l-11.41,5.15c-.3-.87-.61-1.74-.92-2.61",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-13",
  d: "M443.72,332.76l11.41-5.15c.35,1,.68,2,1,3l-11.44,5.08q-.48-1.46-1-2.91",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-12",
  d: "M444.71,335.67l11.44-5.08c.33,1,.65,2,1,3l-11.45,5c-.31-1-.63-1.95-1-2.92",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-11",
  d: "M445.67,338.59l11.45-5c.32,1,.63,2,.93,3l-11.47,4.94c-.3-1-.6-1.95-.91-2.92",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-10",
  d: "M446.58,341.51l11.47-4.94c.39,1.27.77,2.54,1.13,3.81l-11.51,4.84c-.35-1.24-.72-2.48-1.09-3.71",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-9",
  d: "M447.67,345.22l11.51-4.84c.39,1.37.77,2.73,1.13,4.09l-11.53,4.74c-.36-1.33-.72-2.66-1.11-4",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M448.78,349.21l11.53-4.74q.54,2,1.05,4.08l-11.56,4.64c-.33-1.33-.67-2.66-1-4",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-7",
  d: "M449.8,353.19l11.56-4.64q.63,2.55,1.2,5.1L451,358.16q-.56-2.49-1.17-5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-6",
  d: "M451,358.16l11.59-4.51q.57,2.58,1.07,5.15L452,363.19c-.33-1.68-.68-3.35-1-5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-5",
  d: "M452,363.19l11.61-4.39c.37,1.87.71,3.72,1,5.58L453,368.62c-.31-1.8-.64-3.62-1-5.43",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-4",
  d: "M453,368.62l11.64-4.24q.48,2.87.87,5.73l-11.66,4.1q-.39-2.79-.85-5.59",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-37",
  d: "M453.86,374.21l11.66-4.1c.27,1.95.5,3.89.71,5.83l-11.68,4q-.3-2.83-.69-5.69",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-38",
  d: "M454.55,379.9l11.68-4q.3,2.93.51,5.84l-11.69,3.82q-.19-2.85-.5-5.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-39",
  d: "M455.05,385.6l11.69-3.82c.14,2,.25,3.92.32,5.86l-11.7,3.67c-.07-1.89-.17-3.8-.31-5.71",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-40",
  d: "M455.36,391.31l11.7-3.67c.07,1.95.11,3.89.11,5.82L455.47,397c0-1.88,0-3.78-.11-5.68",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-41",
  d: "M455.47,397l11.7-3.53V394l-11.7,3.51V397",
  transform: "translate(0 -23.58)"
}))))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-74"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-75",
  d: "M307.25,144.39l-3.17-1c3-2,7.62-2.75,12.07-2.19l-.4,1.66a13,13,0,0,0-8.5,1.53",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-76",
  d: "M315.75,142.86l.4-1.66a22.58,22.58,0,0,1,4.12.92l-1.62,1.38a15.61,15.61,0,0,0-2.9-.64",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-77",
  d: "M318.65,143.5l1.62-1.38a17.46,17.46,0,0,1,2.76,1.17l-2.44,1a13.44,13.44,0,0,0-1.94-.82",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-78",
  points: "306.27 121.46 303.11 120.45 304.08 119.8 307.25 120.81 306.27 121.46"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-79"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-80",
  d: "M307.73,152.94l-2.55,2.3a13.6,13.6,0,0,1-1.47-.88l3-2.05a10,10,0,0,0,1,.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-81",
  d: "M306.7,152.31l-3,2.05A10.55,10.55,0,0,1,302,152.9l3.5-1.62a7,7,0,0,0,1.21,1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-82",
  d: "M305.49,151.28,302,152.9a7.63,7.63,0,0,1-1.24-1.71l3.87-1.11a5,5,0,0,0,.87,1.2",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-77",
  d: "M304.62,150.08l-3.87,1.11a5.55,5.55,0,0,1-.6-2l4.05-.51a3.5,3.5,0,0,0,.42,1.43",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-76",
  d: "M304.2,148.65l-4.05.51a4.77,4.77,0,0,1,.49-2.47l3.9.22a3.24,3.24,0,0,0-.34,1.74",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-75",
  d: "M304.54,146.91l-3.9-.22a7.06,7.06,0,0,1,2.47-2.65l3.16,1a4.87,4.87,0,0,0-1.73,1.86",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-83"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-84",
  d: "M305.18,155.24l-.25,2.78c-3.51-1.85-5.24-4.42-5-6.85l.25-2.78c-.22,2.43,1.51,5,5,6.85",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-85",
  points: "320.59 120.74 323.03 119.7 378.44 148.96 375.99 150 320.59 120.74"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-86"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-77",
  d: "M376,173.58l2.44-1a.8.8,0,0,1,.16.08l-2.49,1-.11-.06",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-82",
  d: "M376.1,173.64l2.49-1a12.64,12.64,0,0,1,2.14,1.43l-3.12.59a8.81,8.81,0,0,0-1.51-1",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-81",
  d: "M377.61,174.65l3.12-.59a9.15,9.15,0,0,1,1.51,1.55l-3.57.13a6,6,0,0,0-1.06-1.09",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-80",
  d: "M378.67,175.74l3.57-.13a6.33,6.33,0,0,1,.93,1.7l-3.84-.38a4.87,4.87,0,0,0-.66-1.19",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-87",
  d: "M379.33,176.93l3.84.38a4.76,4.76,0,0,1,.3,1.85l-3.93-.92a3.53,3.53,0,0,0-.21-1.31",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-88",
  d: "M379.54,178.24l3.93.92a4.71,4.71,0,0,1-.56,2.06l-3.76-1.53a3.49,3.49,0,0,0,.39-1.45",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-89",
  d: "M379.15,179.69l3.76,1.53a7.13,7.13,0,0,1-2.4,2.53l-3.06-2.28a5.08,5.08,0,0,0,1.7-1.78",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-90"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-91",
  d: "M383.46,179.4l-.25,2.78a4.22,4.22,0,0,1-.1.62l.25-2.77a4.58,4.58,0,0,0,.1-.63",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-92",
  d: "M383.36,180l-.25,2.77a4.23,4.23,0,0,1-.27.83l.25-2.77a6.68,6.68,0,0,0,.27-.83",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-93",
  d: "M383.09,180.86l-.25,2.77a5.93,5.93,0,0,1-.44.82l.25-2.78a6.45,6.45,0,0,0,.44-.81",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-94",
  d: "M382.65,181.67l-.25,2.78a7.05,7.05,0,0,1-.66.83l.25-2.77a7.14,7.14,0,0,0,.66-.84",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-95",
  d: "M382,182.51l-.25,2.77a7.06,7.06,0,0,1-1,.92l.25-2.78a9.14,9.14,0,0,0,1-.91",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-96",
  d: "M381,183.42l-.25,2.78-.46.33.25-2.78.46-.33",
  transform: "translate(0 -23.58)"
})))), React.createElement("polygon", {
  className: "cls-97",
  points: "377.45 157.88 380.51 160.16 379.53 160.82 376.48 158.54 377.45 157.88"
}), React.createElement("polygon", {
  className: "cls-98",
  points: "380.51 160.16 380.26 162.94 379.29 163.59 379.53 160.82 380.51 160.16"
}), React.createElement("polygon", {
  className: "cls-99",
  points: "360.58 160.92 360.33 163.69 304.93 134.44 305.18 131.66 360.58 160.92"
}), React.createElement("polygon", {
  className: "cls-100",
  points: "363.13 158.61 360.58 160.92 305.18 131.66 307.73 129.35 363.13 158.61"
}), React.createElement("path", {
  className: "cls-101",
  d: "M307.25,144.39c3.27-2.19,9.26-2.22,13.34-.07L376,173.58c4.09,2.16,4.74,5.7,1.46,7.89l-1,.65c-3.28,2.2-9.26,2.23-13.35.07l-55.4-29.25c-4.08-2.16-4.74-5.7-1.46-7.89Z",
  transform: "translate(0 -23.58)"
}), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-102"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-96",
  d: "M379.53,184.4l-.24,2.78a12.54,12.54,0,0,1-1.74.95l.25-2.78a11.46,11.46,0,0,0,1.73-.95",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-103",
  d: "M377.8,185.35l-.25,2.78a16.35,16.35,0,0,1-2.64.88l.24-2.78a15.25,15.25,0,0,0,2.65-.88",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-96",
  d: "M375.15,186.23l-.24,2.78a19.68,19.68,0,0,1-3,.47l.25-2.78a19.37,19.37,0,0,0,3-.47",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-95",
  d: "M372.12,186.7l-.25,2.78c-.63.05-1.28.07-1.93.07l.24-2.78c.65,0,1.3,0,1.94-.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-94",
  d: "M370.18,186.77l-.24,2.78c-.55,0-1.1,0-1.65-.07l.24-2.78c.55,0,1.11.07,1.65.07",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-93",
  d: "M368.53,186.7l-.24,2.78c-.5,0-1-.1-1.51-.17l.25-2.78c.5.07,1,.13,1.5.17",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-92",
  d: "M367,186.53l-.25,2.78c-.48-.07-1-.16-1.44-.26l.24-2.78c.48.1,1,.19,1.45.26",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-91",
  d: "M365.58,186.27l-.24,2.78q-.73-.15-1.44-.36l.24-2.77c.48.13,1,.25,1.44.35",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-104",
  d: "M364.14,185.92l-.24,2.77c-.51-.14-1-.31-1.51-.49l.25-2.78c.49.19,1,.35,1.5.5",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-105",
  d: "M362.64,185.42l-.25,2.78c-.59-.22-1.16-.47-1.71-.74l.24-2.78c.56.27,1.13.52,1.72.74",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-84",
  d: "M360.92,184.68l-.24,2.78-.35-.18.25-2.78.34.18",
  transform: "translate(0 -23.58)"
})))), React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-106"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("path", {
  className: "cls-89",
  d: "M376.48,182.12l3,2.28,0,0-3.05-2.29,0,0",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-107",
  d: "M376.45,182.14l3.05,2.29a15.93,15.93,0,0,1-7.5,2.28l-.82-3a11.18,11.18,0,0,0,5.27-1.61",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-89",
  d: "M371.18,183.75l.82,3a22.47,22.47,0,0,1-4.84-.16l.6-2.92a16.37,16.37,0,0,0,3.42.12",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-88",
  d: "M367.76,183.63l-.6,2.92a22,22,0,0,1-3.24-.7l1.57-2.71a14.32,14.32,0,0,0,2.27.49",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-87",
  d: "M365.49,183.14l-1.57,2.71a18.63,18.63,0,0,1-2.62-1l2.34-2.42a12.82,12.82,0,0,0,1.85.7",
  transform: "translate(0 -23.58)"
}), React.createElement("path", {
  className: "cls-80",
  d: "M363.64,182.44l-2.34,2.42q-.37-.17-.72-.36l2.55-2.31.51.25",
  transform: "translate(0 -23.58)"
}))))), React.createElement("g", {
  className: "cls-108"
}, React.createElement("g", {
  className: "cls-2"
}, React.createElement("g", {
  className: "cls-109"
}, React.createElement("path", {
  className: "cls-110",
  d: "M348.65,198.51,119.81,66.39C56.3,29.73,4.65,59.15,4.44,132.14L2.13,949.25c-.21,73,51.11,161.87,114.62,198.54l228.83,132.12c63.51,36.66,115.17,7.23,115.37-65.76L463.27,397c.21-73-51.11-161.86-114.62-198.53",
  transform: "translate(0 -23.58)"
}))))));

var SvgTransparentPhone = function SvgTransparentPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 511.85 1272.09",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransparentPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TransparentPhone.9ddd1de2.svg";
export { ForwardRef as ReactComponent };